"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { Post } from "@/shared/libs/axios/request";
import { orderKeys } from "@/entities/order";
import type { CreateCustomerRequest, CustomerResponse } from "@stocks/shared";

export const useCreateCustomer = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (values: CreateCustomerRequest) =>
      Post<CustomerResponse, CreateCustomerRequest>("/v1/customers", values),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: [orderKeys.customers] });
      toast.success(res.data.message);
    },
    onError: (error) =>
      toast.error(error.response?.data.message ?? "고객 등록에 실패했습니다."),
  });
};
